module.exports = __webpack_public_path__ + "img/titletext.02cffae1.png";